var _path, _path2, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 48 48",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5 38v-24h38v24c0 2.2-1.8 4-4 4h-30c-2.2 0-4-1.8-4-4z",
    fill: "#cfd8dc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43 10v6h-38v-6c0-2.2 1.8-4 4-4h30c2.2 0 4 1.8 4 4z",
    fill: "#f44336"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b71c1c"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 10,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 10,
    r: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#b0bec5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2v-5c0-1.1-.9-2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2s2-.9 2-2v-5c0-1.1-.9-2-2-2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#90a4ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13 20h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 20h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 20h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 20h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 26h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 26h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 26h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 26h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 32h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 32h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 32h4v4h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 32h4v4h-4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.68837847a578f3e0e2cb77007dd7d603.svg";
export { ForwardRef as ReactComponent };